export enum SpendingPer {
  DAY = 'DAY', YEAR = 'YEAR'
}
  